module.exports = __webpack_public_path__ + "static/TrueFiSalesDeck-c2f891499335c955778b643ae04159bb.pdf";